export default __webpack_public_path__ + "static/Facebook360-0b746e958b9ed527fda1e980841db97f.jpg";